import { SaveSlackIntegrationMutation39ifsawios99y as SaveSlackIntegrationMutation } from './schema/SaveSlackIntegrationMutation.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import { toVoidResult8ga34bq1f52r as toVoidResult } from './SdkGrantSlackAccess.mjs';
import { SaveSlackIntegrationInput3jeifrdutkqgi as SaveSlackIntegrationInput } from './schema/type/SaveSlackIntegrationInput.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Dispatcher3kdydho2ojhnk as Dispatcher } from '../../../../../Coupling-libraries-action/com/zegreatrob/coupling/action/party/SaveSlackIntegrationCommand.mjs';
import { GqlTrait2wtoeyl3yfalb as GqlTrait } from './gql/GqlTrait.mjs';
import { initMetadataForInterface1egvbzx539z91 as initMetadataForInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function *_generator_perform__v6ng8j($this, command, $completion) {
  var tmp = $this.o6q(new (SaveSlackIntegrationMutation())(saveSlackIntegrationInput($this, command)), $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp0_safe_receiver = tmp.l44_1;
  return toVoidResult(tmp0_safe_receiver == null ? null : tmp0_safe_receiver.s6g_1);
}
function saveSlackIntegrationInput($this, _this__u8e3s4) {
  var tmp0_team = _this__u8e3s4.p2l_1;
  var tmp1_channel = _this__u8e3s4.o2l_1;
  var tmp2_partyId = _this__u8e3s4.n2l_1;
  return new (SaveSlackIntegrationInput())(tmp2_partyId, tmp0_team, tmp1_channel);
}
function perform(command, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_perform__v6ng8j.bind(VOID, this, command), $completion);
}
var SdkSaveSlackIntegrationCommandDispatcherClass;
function SdkSaveSlackIntegrationCommandDispatcher() {
  if (SdkSaveSlackIntegrationCommandDispatcherClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'SdkSaveSlackIntegrationCommandDispatcher', VOID, VOID, [Dispatcher(), GqlTrait()], [1]);
    SdkSaveSlackIntegrationCommandDispatcherClass = $;
  }
  return SdkSaveSlackIntegrationCommandDispatcherClass;
}
//region block: exports
export {
  SdkSaveSlackIntegrationCommandDispatcher as SdkSaveSlackIntegrationCommandDispatcher1t7cxnysmjc4h,
  perform as performj8mglkenbmy3,
};
//endregion

//# sourceMappingURL=SdkSaveSlackIntegrationCommandDispatcher.mjs.map
